import { ICombinationModel } from '@/src/components/filters';
import { useState } from 'react';
import { FormField2, IDynamicFormValue } from 'src/lib';

export default function useFilterFetch({
  sourceId,
  scenarioId,
  moduleId,
  filterFieldFetchThunk
}: {
  sourceId: number;
  scenarioId?: number;
  moduleId?: number;
  filterFieldFetchThunk: (arg: {
    moduleId: number;
    scenarioId: number;
    sourceId: number;
  }) => Promise<unknown>;
}) {
  const [isFetchingFilterFields, setIsFetchingFilterFields] = useState(false);

  const getFilterFields = (): Promise<{
    fields: FormField2[];
    formValue: IDynamicFormValue;
    combinations: ICombinationModel[];
  }> => {
    setIsFetchingFilterFields(true);
    return filterFieldFetchThunk({ moduleId, scenarioId, sourceId })
      .then((response: any) => {
        if (response['error']) {
          throw Error(response['error']);
        }
        const { formFieldsWithUpdatedOptions, newFormValues, combinations } =
          response.payload as {
            newFormValues: IDynamicFormValue;
            formFieldsWithUpdatedOptions: FormField2[];
            combinations: ICombinationModel[];
          };
        return {
          fields: formFieldsWithUpdatedOptions,
          formValue: newFormValues,
          combinations
        };
      })
      .catch((err) => {
        console.error('Error fetching filters', err);
        setIsFetchingFilterFields(false);
        return {
          fields: [],
          formValue: {},
          combinations: []
        };
      })
      .finally(() => setIsFetchingFilterFields(false));
  };

  return {
    isFetchingFilterFields,
    getFilterFields
  };
}
